<template>
  <div v-if="getterInvalidResponseMsg" class="show-error">
    <p>{{getterInvalidResponseMsg}}</p>
  </div>

  <div v-else class="table-loader">
    <div v-for="index in rows" :key="index" :class="css">
      <p v-for="colIndex in cols" :key="colIndex"></p>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TableLoader',
  props: {
    css: [Object, String],
    clearResponse: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      cols: 3,
      rows: 10
    }
  },
  watch: {
    '$mq': {
      handler: 'populatePanel',
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['getterInvalidResponseMsg'])
  },
  beforeDestroy () {
    if (this.clearResponse) {
      this.SET_INVALID_RESPONSE_MSG(null)
    }
  },
  methods: {
    ...mapMutations(['SET_INVALID_RESPONSE_MSG']),
    populatePanel () {
      if (this.isDesktop()) {
        this.cols = 3
        this.rows = 10
      } else {
        this.cols = 4
        this.rows = 5
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/mixins.scss';

  .show-error {
    border-radius: 5px;
    background: $white;
    @include custom-flex();
  }

  .table-loader {
    > div {
      background: $white;
      border-bottom: 1px solid $grey-outline;
      padding: 12px;

      p {
        background: linear-gradient(to right, $grey-light 20%, $grey-outline 40%, $grey-light 80%);
        background-size: 500px 100px;
        animation: moving-gradient 1s infinite linear;
        height: 12px;
      }

      &.border-layout {
        @include custom-grid-col(repeat(2, auto), 10px);
      }
    }
  }

  .desktop {
    .show-error {
      min-height: 300px;

      p {
        @include highlight-text($grey-text, 20px);
      }
    }

    .table-loader {
      > div {
        &:not(.border-layout) {
          @include custom-grid-col(repeat(3, auto), 10%);
        }
      }
    }
  }

  .mobile, .tablet {
    .show-error {
      padding: 15px;
      margin-top: 10px;
      min-height: 100px;

      p {
        @include highlight-text($grey-text, 16px);
      }
    }

    .table-loader {
      > div {
        &:not(.border-layout) {
          border-radius: 5px;
          margin: 10px 0;
          box-shadow: $card-shadow;
        }

        &:not(.single-side) {
          @include custom-grid-col(repeat(2, auto), 10px);

          p {
            &:nth-child(3) {
              width: 70%;
            }
            &:nth-child(4) {
              width: 70%;
              margin-left: auto;
            }
          }
        }
        &.single-side {
          p {
            margin: 10px 0;

            &:nth-child(odd) {
              width: 85%;
            }
            &:nth-child(even) {
              width: 65%;
            }
          }
        }
      }
    }
  }

  @keyframes moving-gradient {
    0% {
      background-position: -250px 0;
    }
    100% {
      background-position: 250px 0;
    }
  }
</style>
